import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

export default function sliderReviews() {
  let swiper = new Swiper('.reviews__slider', {
    modules: [Navigation, Pagination],
    centeredSlides: true,
    autoHeight: true,
    init: false,
    speed: 800,
    spaceBetween: 16,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      prevEl: '.reviews .swiper-button-prev',
      nextEl: '.reviews .swiper-button-next'
    },
    breakpoints: {
      768: {
        initialSlide: 1,
        autoHeight: false,
        slidesPerView: 1.5,
      },
      1240: {
        initialSlide: 1,
        autoHeight: false,
        slidesPerView: 2.3,
      }
    }
  });
  $(window).on('resize', function() {
    if ($(window).width() < 768) {
      swiper.on('init', function() {
        swiper.slideTo(1);
        swiper.slideTo(0);
      });
    }
  });
  if ($(window).width() < 768) {
    swiper.on('init', function() {
      swiper.slideTo(1);
      swiper.slideTo(0);
    });
  }
  swiper.init();

  let thumbnailItems = $('.reviews__slider .swiper-slide');
  Array.from(thumbnailItems).forEach((item, index) => {
    $(item).on('mouseenter', function() {
      swiper.slideTo(index);
      thumbnailItems.removeClass('swiper-slide-active');
      $(this).addClass('swiper-slide-active');
    });
  });
}
sliderReviews();